import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setSearchRquests } from "../../repository/slice";

function* getSearchRequestsWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/badge/admin/list", payload);
        if (isError) {

        } else {
            yield put(setSearchRquests(data));
        }
    } catch (error) {
        console.error("getSearchRequestsWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getSearchRequestsWatcher() {
    yield takeLatest("@saga/GET_SEARCH_REQUESTS", getSearchRequestsWorker);
};